import { forwardRef } from "react";
import ModalPortal from "components-new/ModalPortal";
import Row from "./Row";
import { useAppSelector } from "toolkit/hooks";
import styles from "./HistoryChanges.module.sass";

interface HistoryChangesProps {
	close: () => void;
}

const HistoryChanges = forwardRef<HTMLDivElement | null, HistoryChangesProps>(({ close }, ref) => {
	const historyChanges = useAppSelector((state) => state.organizations.historyChanges);

	return (
		<ModalPortal className={styles.modal} handleClose={close} title="История изменений" outSide={false} size="lg">
			<div className={styles.table}>
				<div className={styles.tableHead}>
					<div className={styles.tableHeadTd}>Статус</div>
					<div className={styles.tableHeadTd}>Изменил</div>
					<div className={styles.tableHeadTd}>Дата изменения</div>
				</div>
				<div className={styles.tableBody} ref={ref}>
					{historyChanges.map((item) => (
						<Row row={item} />
					))}
				</div>
			</div>
		</ModalPortal>
	);
});

export default HistoryChanges;
